import type { ReactNode } from 'react';
import PageTitle from './PageTitle';

export type PageHeaderProps = {
  /** Primary heading rendered through the existing `<PageTitle>` primitive. */
  heading: string;
  /** Optional subtitle. Rendered as `.axi-page-title__sub`. */
  sub?: string;
  /**
   * Optional right-aligned action slot. Typical contents are
   * "导出 / 添加员工 / 批量审批" buttons. The slot is purely
   * presentational — buttons inside it must receive their own
   * handlers at the call site.
   */
  actions?: ReactNode;
};

/**
 * Page-level heading + actions. Built on top of `<PageTitle>` so we
 * keep a single source of truth for the heading typography, while
 * adding a right-aligned action slot that the bare `<PageTitle>`
 * does not provide.
 *
 * Layout-wise, the heading column is fluid and the actions column is
 * auto-width aligned to the end. Both columns collapse on narrow
 * viewports thanks to the existing container queries on `.axi-page-title`.
 */
function PageHeader({ heading, sub, actions }: PageHeaderProps) {
  return (
    <header className="axi-page-header">
      <PageTitle heading={heading} sub={sub} />
      {actions ? (
        <div className="axi-page-header__actions" role="group" aria-label={`${heading} 操作`}>
          {actions}
        </div>
      ) : null}
    </header>
  );
}

export default PageHeader;